const path = "/app/tools";

export const remoteRouteMeta = [
  {
    type: "redirect",
    key: "REMOTE_CONTROL",
    from: path,
    to: `${path}/remote-control`,
    exact: true,
  },
  { 
    type: "route", 
    key: "REMOTE_CONTROL", 
    path: `${path}/remote-control/*` 
  },
  { 
    type: "route", 
    key: "REMOTE_SUPPORT", 
    path: `${path}/remote-support` 
  },
  { 
    type: "route", 
    key: "WAKE_ON_LAN", 
    path: `${path}/wake-on-lan/*` 
  },
  { 
    type: "route", 
    key: "SHUTDOWN", 
    path: `${path}/shut-down/*` 
  },
  {
    type: "route",
    key: "USER_CONFIRMATION",
    path: `${path}/setting/user-confirmation`,
  },
  { 
    type: "route", 
    key: "PREFERENCES", 
    path: `${path}/setting/preferences` 
  },
  { 
    type: "route", 
    key: "RECORDING", 
    path: `${path}/setting/recording` },
  {
    type: "route",
    key: "CONFIGURE_WOL",
    path: `${path}/setting/configure-wol`,
  },
  {
    type: "route",
    key: "CONFIGURE_WOL",
    path: `${path}/setting/configure-wol`,
  },
  {
    type: "route",
    key: "SESSION_REPORTS",
    path: `${path}/reports/session-reports`,
  },
];